import { useState } from "react";
import { Icon } from "../ui/Icon";
import { env } from "../../lib/env";
import { FeedbackModal } from "./FeedbackModal";
import ChatRoundDotsLinear from "~icons/solar/chat-round-dots-linear";

// ---------------------------------------------------------------------------
// FeedbackFAB — Floating Action Button
// Controlled by VITE_FEATURE_FEEDBACK_ENABLED env var.
// ---------------------------------------------------------------------------

export function FeedbackFAB() {
  const [open, setOpen] = useState(false);

  if (!env.FEATURE_FEEDBACK_ENABLED) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Share feedback"
        className="fixed bottom-6 right-6 z-40 flex size-14 items-center justify-center rounded-full bg-purple-600 text-white shadow-lg transition-transform hover:scale-105 hover:bg-purple-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 active:scale-95"
      >
        <Icon icon={ChatRoundDotsLinear} size="lg" />
      </button>

      <FeedbackModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
